import { render } from "./PhotoPicker.vue?vue&type=template&id=50721c56&scoped=true"
import script from "./PhotoPicker.vue?vue&type=script&lang=js"
export * from "./PhotoPicker.vue?vue&type=script&lang=js"

import "./PhotoPicker.vue?vue&type=style&index=0&id=50721c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50721c56"]])

export default __exports__